import { useEffect, useState } from "react";

import { listCrmTraces, type CrmTraceItem } from "../../api";

function opLabel(op: string): string {
  if (op === "scan.leads") return "SCAN leads";
  if (op === "get.lead") return "GET lead";
  if (op === "put.lead") return "PUT lead";
  if (op === "put.lead.patch") return "PUT lead (patch)";
  if (op === "scan.traces") return "SCAN traces";
  return op;
}

export default function CrmTraces() {
  const [items, setItems] = useState<CrmTraceItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setErr(null);
    listCrmTraces({ limit: 80 })
      .then((r) => setItems(r.items || []))
      .catch((e: unknown) =>
        setErr(e instanceof Error ? e.message : "Impossible de charger les traces")
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-wider text-concrete">
            Debug
          </p>
          <h1 className="font-sans text-3xl font-bold tracking-tight text-black">
            Requêtes DynamoDB
          </h1>
        </div>
        <p className="font-mono text-[11px] text-concrete">
          Items <code className="text-charcoal">TRACE#…</code> dans{" "}
          <code className="text-charcoal">videolink-crm</code>
        </p>
      </header>

      {err && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
          {err}
        </div>
      )}

      <div className="overflow-x-auto rounded-xl border border-stone bg-white shadow-sm">
        {loading ? (
          <p className="p-6 text-concrete">Chargement…</p>
        ) : items.length === 0 ? (
          <p className="p-6 text-concrete">
            Aucune trace pour l’instant. Ouvre /admin/crm/leads puis reviens ici.
          </p>
        ) : (
          <table className="w-full min-w-[760px] text-left text-sm">
            <thead className="border-b border-stone bg-ivory font-mono text-[11px] uppercase tracking-wider text-concrete">
              <tr>
                <th className="px-4 py-3 font-medium">Quand</th>
                <th className="px-4 py-3 font-medium">Op</th>
                <th className="px-4 py-3 font-medium">Admin</th>
                <th className="px-4 py-3 font-medium">Meta</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr
                  key={it.pk}
                  className="border-b border-stone last:border-0"
                >
                  <td className="px-4 py-3 font-mono text-xs text-concrete whitespace-nowrap">
                    {it.created_at ? new Date(it.created_at).toLocaleString() : "—"}
                  </td>
                  <td className="px-4 py-3">
                    <span className="inline-flex items-center rounded-md bg-black px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-wide text-lemonade">
                      {opLabel(it.op || "unknown")}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-concrete">{it.admin_email || "—"}</td>
                  <td className="px-4 py-3">
                    <pre className="max-w-[680px] whitespace-pre-wrap break-words rounded-lg bg-ivory p-3 text-xs text-charcoal">
                      {JSON.stringify(it.meta ?? {}, null, 2)}
                    </pre>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

